import React from "react";
import styled from "styled-components";

const SearchBarUserName = ({ setQuery, name = "projet" }) => {

    const handleChange = (e) => {
        setQuery(e.target.value)
    }

    return (
        <Input type="text"
               placeholder={` Chercher un ${name}`}
               onChange={handleChange}
               className={"search-bar-name"}
        />
    )
}

export default SearchBarUserName;

const Input = styled.input`
  font-size: 0.7em;
  color: var(--color-black);
  border: 1px solid rgba(166, 172, 181, 0.6);
  padding: 0.5em;
  border-radius: 10px;
  background: #ffffff;
  width: 100%;

  &:focus {
    outline: none;
  }
`
